import { Component, Input, HostBinding, Output } from "@angular/core";

@Component({
  selector: "progress-stepper",
  templateUrl: "progress-stepper.component.html",
  styleUrls: ["progress-stepper.component.scss"],
})
export class ProgressStepper {
  @Input()
  steps: Array<string> = [];

  @Input()
  currentStep: string = null;

  @Input()
  showProgress: boolean = true;

  @Input()
  markerColor: string = "#2DBBFC";

  beforeCurrentStep: Array<string> = [];

  ngOnInit() {
    if (this.showProgress && this.currentStep) {
      let i = this.steps.findIndex((x) => x == this.currentStep);
      if (i > -1) {
        this.beforeCurrentStep = this.steps.slice(0, i + 1);
      }
    }
  }
  styleMarker(step: string) {
    if (
      this.currentStep &&
      (this.currentStep == step || this.beforeCurrentStep.includes(step))
    ) {
      return this.markerColor;
    }
    return "none";
  }
  stepNumber(position: number): string | number {
    position = position + 1;
    return position < 10 ? "0" + position : position;
  }
}
